export enum AUTOMATED_EMAILS_TABS {
	CONFIGURATION = 'configuration',
	SCHEDULED_QUEUE = 'scheduled_queue',
}
